import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import { pt, en } from './locales'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translations: en.en,
      },
      'pt-BR': {
        translations: pt['pt-BR'],
      },
    },
    lng: 'pt-BR',
    fallbackLng: 'pt-BR',
    debug: true,

    ns: ['translations'],
    defaultNS: 'translations',

    keySeparator: '.',

    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
